import { t as e } from "./configEditor.translations-DXHXmRwX.js";
import { jsx as t } from "react/jsx-runtime";
import { Icon as n, PromptModal as r } from "@vintecc/components";
import { faTrash as i } from "@vintecc/pro-light-svg-icons";
//#region src/components/DeleteConfirmation/index.tsx
var a = ({ title: a, message: o, onDelete: s, className: c, confirmButtonText: l, confirmButtonIcon: u = /* @__PURE__ */ t(n, { icon: i }) }) => {
	let { t: d } = e();
	return /* @__PURE__ */ t(r, {
		title: a,
		icon: /* @__PURE__ */ t(n, { icon: i }),
		message: o,
		confirmButtonText: l || d("configEditor.actions.delete", "Delete"),
		confirmButtonIcon: u,
		confirmButtonIntent: "error",
		onSubmit: s,
		className: c
	});
};
//#endregion
export { a as t };

//# sourceMappingURL=DeleteConfirmation-Ck6QKDDx.js.map